import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Kontekst} from "../Kontekst";
import {Debugger} from "debug";
import IResourceArray = ng.resource.IResourceArray;

const debug: Debugger = require('debug')('TemaRessurs');

export class TemaRessurs extends BasisRessurs<l.TemaModell> {

    static regNavn = "temaer";

    static forInjisering() {
        return [
            "$resource",
            Kontekst.regNavn,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            TemaRessurs]
    }

    constructor($resource: ng.resource.IResourceService, private kontekst: Kontekst, ressursFeilhåndtering: RessursFeilhåndtering, gettextCatalog: gettextCatalog) {
        super('tema', $resource, ressursFeilhåndtering, gettextCatalog,
            {
                'oppdaterTemaer': {method: 'POST', url: '/api/tema/oppdater', isArray: true},
                'finnAlle': {method: 'GET', url: '/api/tema/:id', isArray: true},
                'finnAktive': {method: 'GET', url: '/api/tema/:id/aktive', isArray: true}
            });
    }

    //offentlige metoder

    alleTema(gruppeId: string): IResourceArray<l.TemaModell> {
        debug("finner alle temaer");

        return this.ressurs['finnAlle'](
            {id: gruppeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente frem temaer")))
    }

    oppdaterTemaer(gruppeId: string, temaer: l.TemaSpesifikasjon[], vedOk: Function = _.noop): IResourceArray<l.TemaModell> {
        debug("Oppdaterer temaer ", temaer);
        return this.ressurs['oppdaterTemaer'](
            {gruppeId: gruppeId, temaer: temaer},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere temaer. Prøv på nytt om litt.")));
    }
}

